package ds.pms.tokafull.adminweb

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.maxHeight
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.url.URL
import org.w3c.files.File

@Composable
fun ProductImageField(
    label: String,
    existingImageUrl: String?,
    pendingFile: File?,
    enabled: Boolean,
    onFileSelected: (File?) -> Unit,
    clearRequested: Boolean = false,
) {
    var objectUrl by remember { mutableStateOf<String?>(null) }

    DisposableEffect(pendingFile) {
        objectUrl?.let { URL.revokeObjectURL(it) }
        objectUrl = pendingFile?.let { URL.createObjectURL(it) }
        onDispose {
            objectUrl?.let { URL.revokeObjectURL(it) }
            objectUrl = null
        }
    }

    val previewUrl = when {
        clearRequested && pendingFile == null -> null
        else -> objectUrl ?: existingImageUrl?.trim()?.takeIf { it.isNotEmpty() }
    }

    P({
        style {
            fontSize(12.px)
            color(org.jetbrains.compose.web.css.Color("#64748B"))
            marginBottom(6.px)
            marginTop(0.px)
            fontWeight("600")
        }
    }) { Text(label) }

    if (previewUrl != null) {
        Div({
            style {
                marginBottom(10.px)
                padding(8.px)
                border(1.px, LineStyle.Solid, org.jetbrains.compose.web.css.Color("#E2E8F0"))
                borderRadius(8.px)
            }
        }) {
            Img(src = previewUrl, attrs = {
                style {
                    maxWidth(220.px)
                    maxHeight(160.px)
                    property("object-fit", "contain")
                    property("display", "block")
                }
            })
        }
    }

    Div({ style { marginBottom(8.px) } }) {
        Input(InputType.File, attrs = {
            attr("accept", "image/jpeg,image/png,image/webp,image/gif")
            if (!enabled) disabled()
            onChange { event ->
                val input = event.target as? HTMLInputElement
                val file = input?.files?.item(0)
                onFileSelected(file)
            }
        })
    }

    if (pendingFile != null || !existingImageUrl.isNullOrBlank()) {
        Button(attrs = {
            if (!enabled) disabled()
            onClick { onFileSelected(null) }
            style {
                padding(8.px, 12.px)
                borderRadius(8.px)
                border(1.px, LineStyle.Solid, org.jetbrains.compose.web.css.Color("#CBD5E1"))
                backgroundColor(org.jetbrains.compose.web.css.Color.white)
                color(org.jetbrains.compose.web.css.Color("#334155"))
                fontSize(12.px)
                property("cursor", "pointer")
                marginBottom(8.px)
            }
        }) { Text("Remove image selection") }
    }

    P({
        style {
            fontSize(11.px)
            color(org.jetbrains.compose.web.css.Color("#94A3B8"))
            marginTop(4.px)
            marginBottom(12.px)
        }
    }) { Text("JPEG, PNG, WebP, or GIF · max 5 MB. Saved on the API server and served at /media/products/.") }
}
